import React, { useCallback } from 'react';
import { Link, NavLink, useHistory, useLocation, matchPath as matchRouterPath } from 'react-router-dom';
import { UdsRoutingProvider, type UdsRoutingProviderProps } from '@utmost.co/utmost-design-system';

interface EnterpriseUdsRoutingProvider {
  children: React.ReactNode;
}

export const EnterpriseUdsRoutingProvider = ({ children }: EnterpriseUdsRoutingProvider) => {
  const history = useHistory();
  const pathname = useLocation().pathname;
  const matchPath: UdsRoutingProviderProps['matchPath'] = useCallback(
    (props) => {
      return !!matchRouterPath(pathname, { exact: props.exact, path: props.path });
    },
    [pathname]
  );

  const navigate: UdsRoutingProviderProps['navigate'] = useCallback(
    (path, options) => {
      history[options?.replace ? 'replace' : 'push'](path, options?.state);
    },
    [history]
  );

  return (
    <UdsRoutingProvider
      Link={Link}
      NavLink={NavLink}
      matchPath={matchPath}
      getLocation={useLocation}
      navigate={navigate}
    >
      {children}
    </UdsRoutingProvider>
  );
};
